import { ReactNode } from 'react';
import { Stack, Title } from '@mantine/core';
import clsx from 'clsx';

export function Layout({
  title,
  children,
  className,
}: {
  title: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Stack gap="md" p="md" className={clsx(className)}>
      <Title order={3}>{title}</Title>
      {children}
    </Stack>
  );
}
